import { render } from "./Inventory_ItemMass_Dialog.vue?vue&type=template&id=aab1f036&scoped=true&ts=true"
import script from "./Inventory_ItemMass_Dialog.vue?vue&type=script&lang=ts"
export * from "./Inventory_ItemMass_Dialog.vue?vue&type=script&lang=ts"

import "./Inventory_ItemMass_Dialog.vue?vue&type=style&index=0&id=aab1f036&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aab1f036"]])

export default __exports__